/*###########################################################################
// Slider intro
//#########################################################################*/

import Swiper from 'swiper'

const sliderIntro = {
  config: {
    sliderIntro: '.sliderIntro'
  },

  elements: {},

  init() {
    const self = this

    self.elements.sliderIntro = document.querySelectorAll(self.config.sliderIntro)

    if (self.elements.sliderIntro !== null) {
      for (let i = 0; i < self.elements.sliderIntro.length; i++) {
        const sliderIntro = self.elements.sliderIntro[i]

        self.handleSliderIntro(sliderIntro)
      }
    }
  },

  handleSliderIntro(slider) {
    const self = this

    const prevBtn = slider.parentNode.querySelector('.slider__control--prev')
    const nextBtn = slider.parentNode.querySelector('.slider__control--next')

    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 700,
      loop: false,
      autoHeight: true,
    })

    if (swiper.isBeginning) {
      prevBtn.classList.add('is-disabled')
    }

    swiper.on('slideChange', function() {
      if (swiper.isBeginning) {
        prevBtn.classList.add('is-disabled')
      }

      if (swiper.isEnd) {
        nextBtn.classList.add('is-disabled')
      }
    })

    swiper.on('fromEdge', function() {
      prevBtn.classList.remove('is-disabled')
      nextBtn.classList.remove('is-disabled')
    })

    swiper.on('reachBeginning', function () {
      if (swiper.isBeginning) {
        prevBtn.classList.add('is-disabled')
      }
    })

    swiper.on('reachEnd', function () {
      if (swiper.isEnd) {
        nextBtn.classList.add('is-disabled')
      }
    })

    prevBtn.addEventListener('click', function (e) {
      swiper.slidePrev()
    })

    nextBtn.addEventListener('click', function (e) {
      swiper.slideNext()
    })
  }
}

window.addEventListener('load', function () {
  sliderIntro.init()
})
